/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Button, Row, Col, Modal, Spinner, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import { Redirect } from 'react-router-dom';

//project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { invoiceDetail, invoiceSendEmail, updateInvoice, transactionHistory, buyerlinkurl, invoicePrintPdf } from 'shared/settings/apiconfig';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import { capitalizeFirstLetter } from 'shared/utils';

//style imports
import './InvoiceView.scss';
import { responseCodeAndStatus } from './DeclinedCardStatus';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to view DG Invoice
 * 
 * @param props
 * 
 * 
 * @param invoiceid
 * 
 * @return html to render DG invoice view
 * 
**/

export class InvoiceGDView extends Component {
    status = { 'paid': 'fa-check-circle', 'unpaid': 'fa-times-circle' }
    constructor(props) {
        super(props);
        this.approveBack = false
        this.state = {
            dgStatus: this.props?.location?.state?.dgStatus,
            DisplayTrackingid: "",
            printPdf: false,
            form: {
                enableEdit: false,
                id: this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1),
                invoiceViewId: this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1),
                billingto: {
                    name: '',
                    addressto1: '',
                    addressto2: '',
                    cityState: '',
                    countryZipcode: '',
                    email: '',
                    phonenumber: ''
                },
                billingfrom: {
                    contactname: '',
                    address1: '',
                    address2: '',
                    cityState: '',
                    countryZipcode: '',
                    contactemail: '',
                    contactmobile: ''
                },
                trackingid: '',
                items: [],
                status: '',
                invoicenumber: '',
                applytaxonbp: '',
                autoDebitStatus: '',
                totalgrossamount: '',
                totalamount: '',
                createddate: '',
                timezone: '',
                totalInvoiceAmount: '',
                totalInvoicePendingAmount: '',
                invoiceStatusAll: '',
                totaltaxonbpamount: '',
                invoicevendor: '',
                type: '',
                invoicemessage: '',
                vipmember: false,
                creditStatus: false,

            },
            errors: {
                transactionID: '',
                amountpaid: '',
                description: '',
            },
            windowWidth: window.innerWidth,
            loading: false,
            isPaidData: false,
            isShippedData: false,
            updateInvoiceData: {
                parentinvoiceid: "",
                invoiceamount: "",
                details: "",
                buyerid: "",
                type: "",
                saleid: ""
            },
            invoiceStatus: { show: false, type: '', message: '' },
            addOnInvoiceStatus: { show: false, type: '', message: '' },
            transactionData: [],
            transactionModal: false,
            errorpageredirect: false,
            invoiceview: 0,
            errorType: ''
        }
        this.stateCopy = { ...this.state };

    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.getInvoiceData();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        if (this.props.location?.state?.state?.name === 'Saledashboard') {
        }
        else {
            window.removeEventListener('popstate', this.onBack);
        }
    }

    /* Detect window width */
    updateDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }

    /* Get invoice data */
    getInvoiceData = () => {
        this.setState({ loading: true });
        axios.get(getSellerUrl(`${invoiceDetail}/${Number(this.state.form.id)}`), getSellerHeaders())
            .then(async response => {
                if (response.status === 200) {
                    if (response.data.status === 'success') {
                        let data = response.data.data[0];
                        let invoicedetail = JSON.parse(response.data.data[0].details);
                        const isCreditUsed = invoicedetail.items.some(item => item.iscreditused === true);
                        let invoiceMessage = invoicedetail.invoicemessage ?  JSON.parse(invoicedetail?.invoicemessage) : ''

                        this.setState({
                            invoiceview: data.invoiceview
                        })
                        if (data.masterinvoiceid && (data.invoicestatus).toLowerCase() != 'void') {
                            this.setState({
                                form: {
                                    ...this.state.form,
                                    id: data.masterinvoiceid,
                                    totalInvoiceAmount: 0,
                                    totalInvoicePendingAmount: 0,
                                    totalInvoiceAmountPaid: 0
                                }
                            })
                            await this.getInvoiceData()
                        } else {
                            if (this.state.form.invoiceViewId == data.id && data.pendingamount === data.invoiceamount) {
                                this.setState({
                                    form: {
                                        ...this.state.form,
                                        enableEdit: true
                                    }
                                });
                            }
                            this.getTransactionData();
                            let invoiceData = JSON.parse(response.data.data[0].details);
                            let billingfromCityDelimiter = invoiceData.billingfrom.city && invoiceData.billingfrom.state ? ', ' : '';
                            let billingfromCountryDelimiter = invoiceData.billingfrom.country && invoiceData.billingfrom.zipcode ? ', ' : '';
                            let billingtoCityDelimiter = invoiceData.billingto.city && invoiceData.billingto.state ? ', ' : '';
                            let billingtoCountryDelimiter = invoiceData.billingto.country && invoiceData.billingfrom.zipcode ? ', ' : '';
                        
                            this.setState({
                                DisplayTrackingid: data.trackshippingid ? data.trackshippingid : '',
                                form: {
                                    ...this.state.form,
                                    billingto: {
                                        ...this.state.form.billingto,
                                        name: invoiceData.billingto.firstname + ' ' + invoiceData.billingto.lastname,
                                        addressto1: (invoiceData.billingto.address1 ? invoiceData.billingto.address1 : '') + (billingtoCityDelimiter) + (invoiceData.billingto.address2 ? invoiceData.billingto.address2 + "," : ''),
                                        cityState: (invoiceData.billingto.city ? invoiceData.billingto.city : '') + (billingtoCityDelimiter) + (invoiceData.billingto.state ? invoiceData.billingto.state : ''),
                                        countryZipcode: (invoiceData.billingto.country ? invoiceData.billingto.country : '') + (billingtoCountryDelimiter) + (invoiceData.billingto.zipcode ? invoiceData.billingto.zipcode : ''),
                                        email: invoiceData.billingto.contactemail ? invoiceData.billingto.contactemail : invoiceData.billingto.email ? invoiceData.billingto.email : '',
                                        phonenumber: invoiceData.billingto.contactmobile ? invoiceData.billingto.contactmobile : invoiceData.billingto.mobile ? invoiceData.billingto.mobile : '',
                                    },
                                    billingfrom: {
                                        ...this.state.form.billingfrom,
                                        contactname: invoiceData.billingfrom.contactname ? invoiceData.billingfrom.contactname : '',
                                        address1: (invoiceData.billingfrom.address1 ? invoiceData.billingfrom.address1 : '') + ',' + (invoiceData.billingfrom.address2 ? invoiceData.billingfrom.address2 + "," : ''),
                                        cityState: (invoiceData.billingfrom.city ? invoiceData.billingfrom.city : '') + (billingfromCityDelimiter) + (invoiceData.billingfrom.state ? invoiceData.billingfrom.state : ''),
                                        countryZipcode: (invoiceData.billingfrom.country ? invoiceData.billingfrom.country : '') + (billingfromCountryDelimiter) + (invoiceData.billingfrom.zipcode ? invoiceData.billingfrom.zipcode : ''),
                                        contactemail: invoiceData.billingfrom.contactemail ? invoiceData.billingfrom.contactemail : invoiceData.billingfrom.email ? invoiceData.billingfrom.email : '',
                                        contactmobile: invoiceData.billingfrom.contactmobile ? invoiceData.billingfrom.contactmobile : invoiceData.billingfrom.mobile ? invoiceData.billingfrom.mobile : '',
                                    },
                                    trackingid: data.trackshippingid ? data.trackshippingid : '',
                                    items: invoiceData.items,
                                    status: data.invoicestatus,
                                    invoiceamount: data.invoiceamount,
                                    pendingamount: data.pendingamount,
                                    invoicenumber: data.invoicenumber,
                                    applytaxonbp: data.applytaxonbp,
                                    autoDebitStatus: response.data.data[0].autoDebitStatus,
                                    createddate: data.createddate ? data.createddate : '',
                                    timezone: data.timezonename ? data.timezonename : '',
                                    masterinvoiceid: data.masterinvoiceid ? data.masterinvoiceid : "---",
                                    masterinvoicenumber: data.masterinvoicenumber ? data.masterinvoicenumber : "---",
                                    totalInvoiceAmount: data.invoiceamount ? (Number(this.state.form.totalInvoiceAmount) + Number(data.invoiceamount)) : Number(this.state.form.totalInvoiceAmount),
                                    totalInvoiceAmountPaid: this.calculatePaymentReceived(data.invoiceamount, data.pendingamount),
                                    totalInvoicePendingAmount: data.pendingamount ? (Number(this.state.form.totalInvoicePendingAmount) + Number(data.pendingamount)) : Number(this.state.form.totalInvoicePendingAmount),
                                    invoiceStatusAll: invoiceData.invoiceStatus,
                                    invoicevendor: data.invoicevendor,
                                    type: data.type,
                                    invoicemessage: invoiceMessage?.content?.body,
                                    vipmember: invoiceData.vipmember,
                                    creditStatus : isCreditUsed,

                                },
                                additionalnotes: data.additionalnotes ? data.additionalnotes : '',
                                loading: false,
                                isShippedData: data.trackshippingid != null ? true : false,
                                updateInvoiceData: {
                                    ...this.state.updateInvoiceData,
                                    parentinvoiceid: data.id != null ? data.id : "",
                                    invoiceamount: data.invoiceamount != null ? data.invoiceamount : "",
                                    details: data.details != null ? data.details : "",
                                    buyerid: data.buyerid != null ? data.buyerid : "",
                                    type: data.type != null ? data.type : "",
                                    saleid: data.saleid != null ? data.saleid : ""
                                }
                            }, () => {
                                this.calculateTotal();
                            });
                        }
                    }
                }
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }

    // get payment received
    calculatePaymentReceived = (invoiceAmount, pendingAmount) => {
        let totalInvoiceAmt = Number(this.state.form.totalInvoiceAmount)
        let totalPendingAmt = Number(this.state.form.totalInvoicePendingAmount)
        if (invoiceAmount) {
            totalInvoiceAmt += Number(invoiceAmount)
        }
        if (pendingAmount) {
            totalPendingAmt += Number(pendingAmount)
        }
        return totalInvoiceAmt - totalPendingAmt
    }

    /* Get transaction history data */
    getTransactionData = () => {
        const data = {
            filter: [
                { field: 'invoiceid', value: Number(this.state.form.id), op: '=', join: 'AND' }
            ]
        };
        this.setState({ pageLoading: true });

        axios.post(getSellerUrl(transactionHistory), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({ transactionData: response.data.data });
                }
            })
            .catch(error => {
                this.setState({ pageLoading: false });
            })
    }

    /* calculate total */
    calculateTotal = () => {
        let amountTotal = 0;
        let grossamountTotal = 0;
        this.state.form.items.forEach(item => {
            amountTotal = amountTotal + parseFloat(item.amount);
            grossamountTotal = grossamountTotal + parseFloat(item.grossamount);

        });
        this.setState({
            form: {
                ...this.state.form,
                totalgrossamount: grossamountTotal ? grossamountTotal : 0,
                totalamount: amountTotal ? amountTotal : 0
            }
        });
    }

    /* Send email to user */
    sendEmail = () => {
        this.setState({ emailLoading: true });
        axios.get(getSellerUrl(`${invoiceSendEmail}/${Number(this.state.form.id)}`), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success')
                    this.setState({
                        emailLoading: false,
                        invoiceStatus: { show: true, type: 'success', message: 'Email sent successfully' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({ invoiceStatus: { show: false, type: '', message: '' } });
                        }, 3000);
                    });
            })
            .catch(error => {
                this.setState({
                    emailLoading: false,
                    invoiceStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    }

    invoicePrintPdf = (value) => {
        this.setState({ printPdf: true });
        let masterinvoiceid = Number(this.state.form.id);
        let invoiceId = [masterinvoiceid];
        const data = {
            "saleid": this.state.updateInvoiceData.saleid,
            "invoiceid": invoiceId,
            "type": value,
        }
        let config = getSellerHeaders();
        config['responseType'] = 'blob';
        axios.post(getSellerUrl(invoicePrintPdf), JSON.stringify({ data }), config).then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = window.URL.createObjectURL(blob);
            window.open(fileURL, '_blank');
            this.setState({ printPdf: false });
        })
    }

    /*Print invoice when clicked print */
    print = () => {
        const printableElements = document.getElementById('invoiceGenration').innerHTML;
        const orderHtml = '<html><head><title></title></head><body>' + printableElements + '</body></html>';
        const oldPage = document.body.innerHTML;
        document.body.innerHTML = orderHtml;
        window.print();
        window.location.reload();
        document.body.innerHTML = oldPage;
    }

    async updateInvoice() {
        this.setState({ updateLoading: true });
        await axios.post(getSellerUrl(updateInvoice), { data: this.state.updateInvoiceData }, getSellerHeaders())
            .then(response => {
                this.setState({
                    updateLoading: false,
                    invoiceStatus: { show: true, type: 'success', message: 'Saved' }
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            invoiceStatus: { show: false, type: '', message: '' }
                        }, () => this.props.history.push('/invoice'));
                    }, 3000);
                });
            })
            .catch(error => {
                this.setState({
                    updateLoading: false,
                    invoiceStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    }

    navigateToList = () => {
        const state = this.props.location.state;
        const {  dgStatus } = this.state;
        if (!state) {
            this.props.history.push({ pathname: '/invoice', state: this.props.location.state })
        }
        if (this.props?.location?.state?.name === "Saledashboard") {
            this.props.history.push({ pathname: this.props.location.state.prevPath, state: state })
        }
        if (state?.name === "Invoice") {
            this.props.history.push({ pathname: '/invoice', state: this.props.location.state })
        }
        if (dgStatus) {
            this.props.history.push({ pathname: this.props.location.state.prevPath, state: this.props.location.state })
        }
    };

    getTransactionMessage = (data) => {
        try {
            if(data) {
                let parsedData = JSON.parse(data) ? JSON.parse(data) : data;
                parsedData = parsedData?.data ? parsedData?.data : parsedData
                let responseCode = parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response ? 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response?.response_code : 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status ? 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status : 
                    parsedData?.name ? parsedData?.name : 
                    parsedData?.resource?.status ? parsedData?.resource?.status :
                    parsedData?.resource?.processor_response?.response_code    

                let message = 
                    responseCode == "0000" && parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status == "COMPLETED" ? "APPROVED" :
                    responseCode == "0000" && parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status == "DECLINED" ? parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason :
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason === "ECHECK" ? responseCodeAndStatus?.["ECHECK"] :
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason === "PENDING_REVIEW" ? responseCodeAndStatus?.["PENDING"] :
                    responseCode == "PENDING" ?  parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason : 
                    parsedData?.name == 'UNPROCESSABLE_ENTITY' ? parsedData?.details[0]?.description : 
                    // (parsedData == "INTERNAL_SERVER_ERROR" || parsedData.name == "INTERNAL_SERVER_ERROR") ? 'PayPal Payment Gateway currently unavailable: This payment could not be processed at this time. Please try again later.' : 
                    (parsedData?.code === 500 ||  parsedData?.name == 'GATEWAY_TIMEOUT' || parsedData?.code === 502 || parsedData == "INTERNAL_SERVER_ERROR" || parsedData?.name == "INTERNAL_SERVER_ERROR"|| parsedData == "error code: 502" || parsedData == "error code: 500") ? 
                    responseCodeAndStatus?.["500"] :
                    parsedData?.status == "PAYER_ACTION_REQUIRED" ? "Payer Action Required - Call Customer to discuss required actions from financial institution." :
                    responseCode == "PPAB" ? "ACCOUNT_BLOCKED_BY_ISSUER" :
                    responseCode == "DECLINED" ? responseCodeAndStatus?.['CTBHD'] : 
                    responseCode == "COMPLETED" ? "Payment approved and completed" : 
                    parsedData?.message ? parsedData.message : responseCode ? `${responseCode} - ${responseCodeAndStatus?.[responseCode]}` : responseCodeAndStatus?.['CTBHD'];
                
                return message ? message : "---"
            } 
        } catch (err) {
            //handle err
        }
        return responseCodeAndStatus?.['CTBHD'];
    }

    render() {
        const { errors } = this.state;
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Invoiceid
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                {this.state.loading ?
                    <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                    <div className="invoiceView container h-90 mt-3" style={{ width: this.state.windowWidth > 425 ? '85%' : '100%' }}>
                        <div className='no-print'>
                            {
                                this.state.form.status.toLowerCase() !== 'void' ?
                                    <div className="d-flex">
                                        <div className="justify-content-start text-left" style={{ width: "50%" }}>
                                            <Button onClick={() => { this.navigateToList() }} style={{ backgroundColor: '#A50050' }}><i className="fa fa-chevron-left"></i> Back</Button>
                                            <Button type="button" className="btn-white m-1" onClick={() => this.setState({ transactionModal: true })}>Transaction History</Button>
                                        </div>
                                        <div className="justify-content-end text-right" style={{ width: "50%" }}>
                                            <Button className="btn-dark m-1" onClick={() => this.invoicePrintPdf("print")}>Print {this.state.printPdf ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                        </div>
                                    </div>
                                    :
                                    <div >
                                        <Button onClick={() => { this.navigateToList() }}><i className="fa fa-chevron-left"></i> Back</Button>
                                    </div>

                            }
                        </div>
                        <div className="invoiceBorder">
                            <div className="print" id="invoiceGenration">
                                <div className={`d-flex ${this.state.windowWidth > 800 ? "flex-row" : ""} p-4 border-bottom ${this.state.windowWidth > 800 ? '' : 'row'}`}>
                                    <div className={` ${this.state.windowWidth > 800 ? 'justify-content-left text-left w-50' : 'justify-content-center text-center'} col-md-6 col-xs-12`}>
                                        <div className='d-flex align-items-center media-screen'>
                                            <img className="seel-img" style={{ borderRight: "4px solid #000000", height: "40px", width: "130px", paddingRight: "10px", paddingBottom: "3px"  }} src={`${process.env.PUBLIC_URL}/static/logo/seel.png`} alt="logo" />
                                            <img src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} style={{ marginLeft: "5px" }} alt="logo" height="60px" width="170px" />
                                        </div>
                                        <div><b>Delivery Guarantee Provided By Seel</b></div>
                                        {this.state.form.status === 'paid' && <span className="text-success"><i className={`fa ${this.status[this.state.form.status]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{this.state.form.status}</span>}
                                    </div>
                                    <div className={`${this.state.windowWidth > 800 ? 'justify-content-end text-right w-50 mt-3' : 'justify-content-center text-center mt-1'}  col-md-6`}>
                                        {this.state.form.type ? 
                                            <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px", whiteSpace: 'nowrap', color: '#00263E' }}><b className='text-secondary'>Invoice Type:</b>  {this.state.form.type == "DG" ? "Delivery Guaranteed (DG)" : "  - - -"}</div></div> : ""
                                        }
                                        {this.state.DisplayTrackingid ?
                                            <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px", whiteSpace: 'nowrap' }}>Tracking Id: {this.state.DisplayTrackingid ? this.state.DisplayTrackingid : "  - - -"}</div></div> : ""
                                        }
                                    </div>
                                </div>
                                <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  border-bottom mx-0`}>
                                    <div className={`col col-xs-12 padding col-md-6`}>
                                        <p><b className="text-secondary"> Billing To </b></p>
                                        {Object.keys(this.state.form.billingto).map((key) =>
                                            key === 'name' ? <p><b>{this.state.form.billingto[key]}</b></p> :
                                                key === 'phonenumber' ? this.state.form.billingto[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {this.state.form.billingto[key]}</p> : '' :
                                                    key === 'email' ? this.state.form.billingto[key] ? <p style={{ color: "#1d9aa5", wordBreak: 'break-all' }}>{this.state.form.billingto[key]}</p> : '' : <p style={{ wordBreak: 'break-all' }}>{this.state.form.billingto[key]}</p>
                                        )}
                                    </div>
                                    <div className={`col col-xs-12 padding col-md-6`}>
                                        <p><b className="text-secondary">Billing From</b></p>
                                        {Object.keys(this.state.form.billingfrom).map((key) =>
                                            key === 'contactname' ? <p><b>{this.state.form.billingfrom[key]}</b></p> :
                                                key === 'contactmobile' ? this.state.form.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {this.state.form.billingfrom[key]}</p> : '' :
                                                    key === 'contactemail' ? this.state.form.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>{this.state.form.billingfrom.contactemail} </p> : '' : <p>{this.state.form.billingfrom[key]}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={` p-4 border-bottom mx-0`}>
                                    <div style={{ fontSize: "20px" }}><p><b className="text-secondary">Invoice Details</b></p>
                                    </div>
                                </div>
                                <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  mx-0`}>

                                    <div className="col  col-xs-12 padding"><div >
                                        <p className={` text-secondary col-xs-12`} ><b style={{ fontSize: "20px" }}>Invoice: {this.state.form.invoicenumber}    </b>
                                            {<span className={`${this.state.form.status.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                                <i className={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{this.state.form.status.toUpperCase()}</span>}</p></div></div>
                                    <div className=" d-flex flex-row justify-content-end text-end" >
                                        {
                                            this.state.invoiceStatus.show ?
                                                <ToasterMessage type={this.state.invoiceStatus.type} message={this.state.invoiceStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                                : null
                                        }
                                    </div>
                                    <div className="col col-xs-12 padding" style={{ textAlign: "right" }}>
                                        <p><b className="text-secondary">Invoice Date :- </b><b>{moment.utc(this.state.form.createddate).local().format('MM/DD/YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></p>
                                        <Button className="btn-white " style={{ border: "1px solid #A50050" }} onClick={() => this.sendEmail()} disabled={this.state.invoiceStatus.type === 'success'}>Send Email {' '} {this.state.emailLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                    </div>
                                </div>
                                <div style={{ overflowX: "auto" }} className={` p-4 border-bottom mx-0`}>
                                    {this.state.form.items.length > 0 && <Table className="amountfields" responsive style={{ height: "100%" }}>
                                        <thead>
                                            <tr style={{ color: "#A50050", flexWrap: "nowrap" }}>
                                                <td style={{ paddingLeft: "2.5rem" }}>Item Title</td>
                                                <td>SKU</td>
                                                {!this.state.invoiceview ? <td>IRM</td> : null}
                                                <td>DG Amount</td>
                                                <td></td>
                                                <td style={{ paddingRight: "0.5rem" }}>Gross Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.form.items.map((item, index) => (
                                                    <tr>
                                                        <td style={{ paddingLeft: "2.5rem", width: '25%' }}><a href={item.itemviewurl ? item.itemviewurl : `${buyerlinkurl}${this.state.updateInvoiceData.saleid}/item/${item.id}`} target="_blank">{item.title}</a></td>
                                                        <td style={{ wordBreak: 'break-all' }}>{item.SKU ? item.SKU : "- - -"}</td>
                                                        {!this.state.invoiceview ? <td style={{ whiteSpace: "nowrap" }}>{item.bidderirm ? capitalizeFirstLetter(item.bidderirm) : '- - -'}</td> : null}
                                                        <td style={{ whiteSpace: "nowrap" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : `- - -${item.iscreditused ?  '**' : ''}`}</td>
                                                        <td></td>
                                                        <td style={{ paddingRight: "2.5rem", whiteSpace: "nowrap" }}>{item.grossamount ? `$ ${parseFloat(item.grossamount).toFixed(2)}` : `- - -${item.iscreditused ?  '**' : ''}`}</td>
                                                    </tr>
                                                ))
                                            }
                                            <tr style={{ fontWeight: "bold", flexWrap: "nowrap" }}>
                                                <td></td>
                                                {!this.state.invoiceview ? <td></td> : null}
                                                <td></td>
                                                <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalamount).toFixed(2)}</td>
                                                <td></td>
                                                <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalgrossamount).toFixed(2)}</td>
                                            </tr>

                                        </tbody>
                                    </Table>
                                    }
                                </div>

                                <div className="serviceview" style={{marginBottom: '60px'}}>
                                    <Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "15px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "30%" }}>{this.state.form.totalInvoiceAmount ? `$ ${parseFloat(this.state.form.totalInvoiceAmount).toFixed(2)}` : '$ 0.00'}</b></Col>
                                    </Row>
                                    { this.state.form.vipmember ? 
                                        <Row className="" >
                                            <Col></Col>
                                            <Col className="text-right text-secondary" ><b>Your Cost</b></Col>
                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "15px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "30%" }}>{"$ 0.00"}</b></Col>
                                        </Row> :
                                        <Row className="" >
                                            <Col></Col>
                                            <Col className="text-right text-secondary" ><b>Payments Received </b></Col>
                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "15px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "30%" }}>{this.state.form.totalInvoiceAmountPaid ? `$ ${parseFloat(this.state.form.totalInvoiceAmountPaid).toFixed(2)}` : '$ 0.00'}</b></Col>
                                        </Row> 
                                    }
                                </div>

                                {this.state.form.creditStatus  ? <h5 className='pr-4 my-5' style={{ paddingLeft: "4%" }} >
                                    ** Premier member credit applied  
                                    </h5> : ''}
                            </div>
                            <div className={`d-flex flex-column pr-4 invoice-message-wraper ${this.state.windowWidth > 1800 ? 'my-5' : 'my-4'}`} style={{ paddingLeft: "4%", textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: this.state?.form?.invoicemessage }}></div>

                        </div>
                    </div>
                }

                <Modal size="xl" id="transactionModal" show={this.state.transactionModal} centered onHide={() => this.setState({ transactionModal: false })}>
                    <Modal.Header closeButton>
                        <h5 className="text-secondary"><b>Transaction History</b></h5>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ overflowX: 'scroll' }} >
                            <table className="table">
                                <tbody>
                                    <tr className=" header" >
                                        <td>Ctbids Transaction Id</td>
                                        <td>Date</td>
                                        <td>Invoice Number</td>
                                        <td>Transaction Type</td>
                                        <td>Payment Mode</td>
                                        <td>PayPal Transaction ID</td>
                                        <td>PayPal Status</td>
                                        <td>Amount</td>
                                        <td>Notes</td>
                                        <td>Response Code</td>
                                    </tr>
                                    {this.state.transactionData.length ?
                                        this.state.transactionData.map(data =>
                                            <tr>
                                                <td>{data.referencenumber ? data.referencenumber : '- - -'}</td>
                                                <td style={{ whiteSpace: "nowrap" }}>{data.createddate ? `${moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : '- - -'}</td>
                                                <td>{data.invoicenumber ? data.invoicenumber : '- - -'}</td>
                                                <td>{data.credit ? 'Credit' : ''}</td>
                                                <td>{data.paymentmode ? data.paymentmode : '- - -'}</td>
                                                <td>{data.paymentreference ? data.paymentreference : '- - -'}</td>
                                                <td>{data.paypalstatus ? data.paypalstatus.toLowerCase() : data.status ? data.status.toLowerCase() : '- - -'}</td>
                                                <td style={{ whiteSpace: "nowrap" }}>{data.amount ? `$ ${data.amount.toFixed(2)}` : '- - -'}</td>
                                                <td style={{ wordWrap: 'break-word' }}>{data.comments ? data.comments : 'Manual payment'}</td>
                                                <td>{data.tranresponse ?
                                                    <div>
                                                        <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.getTransactionMessage(data.tranresponse)}</Tooltip>}>
                                                            <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                        </OverlayTrigger>
                                                    </div> : '- - -'}
                                                </td>
                                            </tr>
                                        ) :
                                        <tr><td colSpan="10"><h5 className="noData" >No data available</h5></td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}